import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Spin, Modal, Form, Input, Row, Col, Select } from 'antd';
import { BasicFormWrapper, SpinerCustomStyle } from '../container/styled';
import propTypes from 'prop-types';
import { validatorTcNo } from '../utility/andtCustomValidator';
import { Button } from '../components/buttons/buttons';
import formHelper from '../utility/formHelper';
import NotificationHelper from '../utility/notificationHelper';

import InputNumber from '../components/input/inputNumber';
import serviceHelper from '../utility/serviceHelper';

const { Option } = Select;

function KullaniciTayinIslemi({ isModalVisible, handleCancel }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const initialState = {
    userDetail: {},
    currentStep: 0,
    visibleStatus: false,
    loading: false,
    kurumNodeList: [],
    userNode: {
      value: null,
      name: null,
    },
  };

  const [state, setState] = useState(initialState);

  const next = () => {
    setState((prev) => ({
      ...prev,
      currentStep: prev.currentStep + 1,
    }));
  };

  const previous = () => {
    setState((prev) => ({
      ...prev,
      currentStep: prev.currentStep - 1,
    }));
  };

  const selectChange = (value, name) => {
    setState((prev) => ({ ...prev, userNode: { value: value?.toString(), name } }));
  };

  const getKurumNodeList = async () => {
    const response = await serviceHelper.KurumNodeList();
    setState({
      ...state,
      kurumNodeList: response,
    });
  };

  useEffect(() => {
    getKurumNodeList();
  }, []);

  const SubmitForm = async () => {
    try {
      const isValid = await form.validateFields().catch(() => false);

      if (!isValid) {
        NotificationHelper.setErrorNotification(t('tcNoLineRule'));
        return;
      }

      const formValue = formHelper.getFormValues(form);

      setState((prev) => ({ ...prev, loading: true }));

      if (!formHelper.isEmptyFieldVal(formValue)) {
        const res = await formHelper.formSubmit(
          `${process.env.REACT_APP_MUHENDIS_KULLANICI_GIRISI_TC_NO_ENDPOINT}`,
          {
            ...formValue,
          },
          'post',
          true,
        );

        console.log(res);

        if (res.responseStatus || res.responseData.isSuccess) {
          setState((prev) => ({ ...prev, userDetail: res.responseData.model, visibleStatus: true, loading: false }));
          next();
        }
        setState((prev) => ({ ...prev, loading: false }));
      }
    } catch (error) {
      setState((prev) => ({ ...prev, loading: false }));
      NotificationHelper.setErrorNotification(t('processUnexpectedError'));
    }
  };

  const UserSubmitForm = async () => {
    try {
      const formValue = formHelper.getFormValues(form);

      setState((prev) => ({ ...prev, loading: true }));

      if (!formHelper.isEmptyTayinIslemiFieldVal(formValue)) {
        const res = await formHelper.formSubmit(
          `${process.env.REACT_APP_MUHENDIS_KULLANICI_GIRISI_ENDPOINT}`,
          {
            IdStr: state.userDetail.idStr,
            KurumIdStr: state.userNode.value,
          },
          'post',
          true,
        );

        console.log(res);

        if (res.responseStatus || res.responseData.isSuccess) {
          setState((prev) => ({ ...prev, loading: false }));
          handleCancel();
        }
        setState((prev) => ({ ...prev, loading: false }));
      }
      setState((prev) => ({ ...prev, loading: false }));
    } catch (error) {
      setState((prev) => ({ ...prev, loading: false }));
      handleCancel();
      NotificationHelper.setErrorNotification(t('processUnexpectedError'));
    }
  };

  return (
    <div>
      <Modal title={t('menu.yonetim.tayinİslemi')} visible={isModalVisible} onCancel={handleCancel} footer={null}>
        {state.loading && (
          <SpinerCustomStyle>
            <Spin />
          </SpinerCustomStyle>
        )}

        <div className="wizard-side-border">
          <div className="steps-content">
            {/* Step 1 */}
            {state.currentStep === 0 && (
              <BasicFormWrapper className="basic-form-inner">
                <Row justify="center">
                  <Col xs={24}>
                    <Form form={form} name="vergiNumarasi">
                      <Form.Item name="tcNo" label="TC Kimlik No" required>
                        <InputNumber maxLength={11} integerOnly placeholder="TC Kimlik No Girin" />
                      </Form.Item>
                      <Button type="success" size="large" onClick={SubmitForm}>
                        {t('ileri')}
                      </Button>
                    </Form>
                  </Col>
                </Row>
              </BasicFormWrapper>
            )}

            {/* Step 2 */}
            {state.currentStep === 1 && state.visibleStatus && (
              <BasicFormWrapper className="basic-form-inner">
                <Row justify="center">
                  <Col xs={24}>
                    <Form form={form} name="adres">
                      <Form.Item name="ad" initialValue={state.userDetail?.ad} label={t('ad')}>
                        <Input disabled />
                      </Form.Item>

                      <Form.Item name="soyad" initialValue={state.userDetail?.soyad} label={t('soyad')}>
                        <Input disabled />
                      </Form.Item>

                      <Form.Item name="telefon" initialValue={state.userDetail?.telefon} label={t('telefon')}>
                        <Input disabled />
                      </Form.Item>

                      <Form.Item name="email" initialValue={state.userDetail?.email} label={t('eposta')}>
                        <Input disabled />
                      </Form.Item>

                      <Form.Item name="kurum" initialValue={state.userDetail?.kurum} label={t('kurum')}>
                        <Input disabled />
                      </Form.Item>

                      <Form.Item name="unvan" initialValue={state.userDetail?.unvan} label={t('meslek')}>
                        <Input disabled />
                      </Form.Item>

                      <Form.Item name="KurumIdStr" initialValue="Seçiniz" label={t('tayinEdilecekKurum')}>
                        <Select
                          getPopupContainer={(trigger) => trigger.parentNode}
                          placeholder={t('kontrolKurumu')}
                          onChange={(value) => {
                            selectChange(value, 'KurumIdStr');
                          }}
                          className="width-100"
                          name="KurumIdStr"
                          size="small"
                          showSearch
                          allowClear
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            const label = option.children.toLocaleLowerCase('tr-TR');
                            const search = input.toLocaleLowerCase('tr-TR');
                            return label.includes(search);
                          }}
                        >
                          {state.kurumNodeList &&
                            state.kurumNodeList.map((kurum) => <Option value={kurum.Id}>{kurum.Ad}</Option>)}
                        </Select>
                      </Form.Item>

                      {/* <Button type="default" onClick={previous}>
                          {t('geri')}
                        </Button> */}
                      <Button type="success" size="large" onClick={UserSubmitForm}>
                        {t('tayinIsleminiTamamla')}
                      </Button>
                    </Form>
                  </Col>
                </Row>
              </BasicFormWrapper>
            )}

            {/* Step 3 */}
            {state.currentStep === 2 && (
              <div>
                <h4>Kullanıcı Bilgileri</h4>
                {/* Burada state.userDetail ile kullanıcı bilgilerini gösterebilirsiniz */}
                <pre>{JSON.stringify(state.userDetail, null, 2)}</pre>
                <Button type="default" onClick={previous}>
                  {t('geri')}
                </Button>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}

KullaniciTayinIslemi.propTypes = {
  isModalVisible: propTypes.bool.isRequired,
  handleCancel: propTypes.func.isRequired,
};

export default KullaniciTayinIslemi;
